module.exports = __webpack_public_path__ + "static/media/GT-Alpina-Bold.4160e403.woff";